var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.getRouteName}}),_c('NavLinks'),_c('transition',{staticStyle:{"display":"none"},attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }